import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import reportWebVitals from './reportWebVitals';

import Services from './services';

import WebApps from './WebApps';
import _3dSimulation_01 from './3d-simulation-01'
import _3dSimulation_02 from './3d-simulation-02'
import _3dSimulation_03 from './3d-simulation-03'
import LissajousReactApp from './LissajousReactApp';
import DrumMachineReactApp from './DrumMachineReactApp';
import WorkletDrumMachine from './AudioWorklet-DrumMachine/drum-machine';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <WebApps />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
